import { Editor, Location, Point } from 'slate';

export function isEnd(editor: Editor, point: Point | null | undefined, at: Location) {
    return !!point && Editor.isEnd(editor, point, at);
}
